export const MAIL_LIVE_SYNC_DONE_EVENT = "mailLiveSyncDone";

export type MailLiveSyncDoneDetail = {
  accountId: number;
  folder: string;
};

export function notifyMailLiveSyncDone(accountId: number, folder: string): void {
  window.dispatchEvent(
    new CustomEvent<MailLiveSyncDoneDetail>(MAIL_LIVE_SYNC_DONE_EVENT, {
      detail: { accountId, folder },
    })
  );
}
